import React from 'react';
import CompactTableRow from '@/components/table/CompactTableRow';

const CohortSettingVisibilityWarning = () => (
  <CompactTableRow
    warning
    className="aridhia-cohort-setting-visibility-warning-row"
    rowId="dataset.settings.cohort.enabled.warning"
    numberOfColumns={3}
  />
);

export default CohortSettingVisibilityWarning;
